import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Logo } from "@/components/site/Header";

export const POLICY_LINKS = [
  ["terms", "Terms & Conditions"],
  ["privacy", "Privacy Policy"],
  ["application-fee-refund", "Application Fee & Refund Policy"],
  ["recruitment-disclaimer", "Recruitment Disclaimer"],
  ["product-returns", "Product Return & Refund Policy"],
  ["shipping", "Shipping & Delivery Policy"],
  ["cancellation", "Cancellation Policy"],
  ["distributor-terms", "Distributor Terms & Conditions"],
  ["distributor-refund", "Distributor Refund & Cancellation Policy"],
];

export const useSettings = () => {
  const [s, setS] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);
  return s;
};

export const Footer = () => {
  const s = useSettings();
  return (
    <footer className="no-print mt-24 bg-slate-950 text-slate-300">
      <div className="container-x grid gap-10 py-16 md:grid-cols-4">
        <div className="space-y-4 md:col-span-1">
          <Logo light />
          <p className="text-sm leading-relaxed text-slate-400">Genuine SP Quick Wash household cleaning products, a transparent distributor network and careers at BMI SP GROUP.</p>
        </div>
        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-amber-500">Explore</h4>
          <ul className="space-y-2 text-sm">
            {[["/packages", "Distributor Packages"], ["/distributor/register", "Distributor Registration"], ["/member/login", "Member Login"], ["/products", "Product Catalogue"], ["/careers", "Careers"], ["/my-applications", "My Applications"], ["/my-orders", "My Orders"], ["/about", "About Us"], ["/admin", "Admin Login"]].map(([to, l]) => (
              <li key={to}><Link to={to} className="hover:text-white">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-amber-500">Policies</h4>
          <ul className="space-y-2 text-sm">
            {POLICY_LINKS.map(([slug, l]) => (
              <li key={slug}><Link to={`/policies/${slug}`} className="hover:text-white" data-testid={`footer-policy-${slug}`}>{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-widest text-amber-500">Contact</h4>
          <ul className="space-y-2 text-sm text-slate-400" data-testid="footer-contact">
            <li>{s.address}</li>
            <li>Phone: {s.phone}</li>
            <li>Email: {s.email}</li>
            <li><Link to="/contact" className="text-white underline-offset-4 hover:underline">Contact Us</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <p className="container-x py-6 text-xs leading-relaxed text-slate-500">
          Recruitment disclaimer: submitting an application or paying the application processing fee does not guarantee employment, an interview or selection. Final recruitment depends on eligibility, verification, interviews and the company's genuine requirements. Product purchases are separate from job applications. © {new Date().getFullYear()} BMI SP GROUP.
        </p>
      </div>
    </footer>
  );
};
